<template>
    <div class="min-vh-100">
        <b-container style="padding-top:120px">
            <div class="text-center">
                <b-img style="width:128px; margin-bottom:2rem" :src="img" fluid></b-img>
                <h4 class="text-success mb-3"><b-icon-check-circle-fill></b-icon-check-circle-fill> 報名資料已送出</h4>
                <p class="text-warning font-weight-bold mb-4">未付款前不代表報名成功，也不保留名額</p>
                <b-button variant="primary" size="lg" @click="_go('/')">回首頁</b-button>
            </div>
        </b-container>
    </div>
</template>

<script>
export default {
    name: 'CampRegistrationComplete',
    data() {
        return {
            img: require('@/assets/success.png'),
        };
    },
};
</script>
